/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotLanguageMetric extends models.CopilotMetricActivityBase {
    getFixupPrototypeFunction() { return CopilotLanguageMetric.fixupPrototype; }

    static newInstance(model: Partial<CopilotLanguageMetric>): CopilotLanguageMetric {
        let obj = Object.assign(new CopilotLanguageMetric(), model);
        CopilotLanguageMetric.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotLanguageMetric>): CopilotLanguageMetric {
        if (!model) return null;
        return CopilotLanguageMetric.newInstance(<CopilotLanguageMetric> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotLanguageMetric) {
        if (!obj) return;

        models.CopilotLanguageMetric.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotLanguageMetric): boolean {
        if (models.CopilotMetricActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotLanguageMetric.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Programming language name (e.g. python, javascript)
     */
    name: string;

}
